// Pure, side-effect-free path helpers for the OnlineOrdering SDK.
// Split out from online-ordering.ts so they can be unit-tested in isolation
// (no history / DOM / module bootstrap) and so the SDK entry keeps a single
// default export (no mixed named/default IIFE export).

// Leading slash, no trailing slash: '/orders'. '/' collapses to '' which we
// then treat as root — but a base-path of '/' defeats the overlay, so callers
// should keep a real sub-path.
export const normalizeBase = (p: string): string => '/' + String(p).replace(/^\/+|\/+$/g, '');

/**
 * Router-relative path each SDK entry point navigates to. `navigate()` is what
 * actually applies the result — this only computes the string.
 *   - 'home'      → `<basePath>`                       (e.g. "/orders")
 *   - 'locations' → `<basePath>/locations`
 *   - 'store'     → `<basePath>/store/<encoded slug>`
 */
export const buildOrderingPath = (
  basePath: string,
  view: 'home' | 'locations' | 'store',
  slug?: string
): string => {
  if (view === 'locations') return `${basePath}/locations`;
  if (view === 'store') return `${basePath}/store/${encodeURIComponent(slug ?? '')}`;
  return basePath;
};
